import React from "react";
import { Routes, Route } from "react-router-dom";
import ProfileEdit from "./ProfileEdit";
import Security from "./Security";

const ProfileRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ProfileEdit />} />
      <Route path="security" element={<Security />} />
    </Routes>
  );
};

export default ProfileRoutes;
